export default "__VITE_PUBLIC_ASSET__43abc589__"